import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FServiceAPI } from '@freelog/tools-lib';
import { decompile } from '@freelog/nmr_translator';
import { ruleMatchAndResult } from '@/models/informalNodeManagerPage';
import type { IRules, RuleMatchAndResultReturn } from '@/models/informalNodeManagerPage';
import fMessage from '@/components/fMessage';
import { mergeRules } from './helpers';
import type {
  ChangeAction,
  FetchInformalExhibitInfoAction,
  OnChange_Side_Exhibit_Cover_Action,
  OnClickPTitleEditBtnAction,
  OnChangePTitleInputAction,
  OnClick_Side_Exhibit_Title_Action,
  OnClickPTitleCancelBtnAction,
  OnChange_Side_Exhibit_Tags_Action,
  OnChange_Side_Exhibit_Version_Action,
} from './types';

export const sideExhibitEffects = {
  * onChange_Side_Exhibit_Cover({ payload }: OnChange_Side_Exhibit_Cover_Action, {
    select,
    call,
    put,
  }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_Exhibit_Cover: payload.value,
      },
    });

    const { informExhibitInfoPage }: ConnectState = yield select(({ informExhibitInfoPage }: ConnectState) => ({
      informExhibitInfoPage,
    }));

    const rules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> = (informExhibitInfoPage.node_RuleInfo?.testRules || []).map((rr) => {
      return rr.ruleInfo;
    });

    const text: string = decompile(mergeRules({
      oldRules: rules,
      exhibitName: informExhibitInfoPage.exhibit_Name,
      action: {
        operation: 'set_cover',
        content: payload.value,
      },
    }));

    const params: Parameters<typeof FServiceAPI.InformalNode.createRules>[0] = {
      nodeId: informExhibitInfoPage.node_ID,
      testRuleText: text,
    };
    const { data } = yield call(FServiceAPI.InformalNode.createRules, params);

    const params2: Parameters<typeof ruleMatchAndResult>[0] = {
      nodeID: informExhibitInfoPage.node_ID,
      isRematch: true,
    };

    const result: RuleMatchAndResultReturn = yield call(ruleMatchAndResult, params2);
    if (result.status === 2) {
      fMessage('规则匹配失败');
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        node_RuleInfo: result,
      },
    });

    yield put<FetchInformalExhibitInfoAction>({
      type: 'fetchInformalExhibitInfo',
    });
  },
  * onClickPTitleEditBtn({}: OnClickPTitleEditBtnAction, { put, select }: EffectsCommandMap) {

    const { informExhibitInfoPage }: ConnectState = yield select(({ informExhibitInfoPage }: ConnectState) => ({
      informExhibitInfoPage,
    }));

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_Exhibit_InputTitle: informExhibitInfoPage.side_Exhibit_Title,
      },
    });
  },

  * onChangePTitleInput({ payload }: OnChangePTitleInputAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_Exhibit_InputTitle: payload.value,
      },
    });
  },
  * onClick_Side_Exhibit_Title({}: OnClick_Side_Exhibit_Title_Action, { put, select, call }: EffectsCommandMap) {

    const { informExhibitInfoPage }: ConnectState = yield select(({ informExhibitInfoPage }: ConnectState) => ({
      informExhibitInfoPage,
    }));

    const pInputTitle: string = informExhibitInfoPage.side_Exhibit_InputTitle || '';

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_Exhibit_Title: pInputTitle,
        side_Exhibit_InputTitle: null,
      },
    });

    const rules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> = (informExhibitInfoPage.node_RuleInfo?.testRules || []).map((rr) => {
      return rr.ruleInfo;
    });

    const text: string = decompile(mergeRules({
      oldRules: rules,
      exhibitName: informExhibitInfoPage.exhibit_Name,
      action: {
        operation: 'set_title',
        content: pInputTitle,
      },
    }));

    const params: Parameters<typeof FServiceAPI.InformalNode.createRules>[0] = {
      nodeId: informExhibitInfoPage.node_ID,
      testRuleText: text,
    };
    const { data } = yield call(FServiceAPI.InformalNode.createRules, params);

    const params2: Parameters<typeof ruleMatchAndResult>[0] = {
      nodeID: informExhibitInfoPage.node_ID,
      isRematch: true,
    };

    const result: RuleMatchAndResultReturn = yield call(ruleMatchAndResult, params2);
    if (result.status === 2) {
      fMessage('规则匹配失败');
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        node_RuleInfo: result,
      },
    });

    yield put<FetchInformalExhibitInfoAction>({
      type: 'fetchInformalExhibitInfo',
    });
  },
  * onClickPTitleCancelBtn({}: OnClickPTitleCancelBtnAction, { put }: EffectsCommandMap) {

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_Exhibit_InputTitle: null,
      },
    });
  },
  * onChange_Side_Exhibit_Tags({ payload }: OnChange_Side_Exhibit_Tags_Action, {
    put,
    select,
    call,
  }: EffectsCommandMap) {

    const { informExhibitInfoPage }: ConnectState = yield select(({ informExhibitInfoPage }: ConnectState) => ({
      informExhibitInfoPage,
    }));

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_Exhibit_Tags: payload.value,
      },
    });

    const rules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> = (informExhibitInfoPage.node_RuleInfo?.testRules || []).map((rr) => {
      return rr.ruleInfo;
    });

    const text: string = decompile(mergeRules({
      oldRules: rules,
      exhibitName: informExhibitInfoPage.exhibit_Name,
      action: {
        operation: 'set_labels',
        content: payload.value,
      },
    }));

    const params: Parameters<typeof FServiceAPI.InformalNode.createRules>[0] = {
      nodeId: informExhibitInfoPage.node_ID,
      testRuleText: text,
    };
    const { data } = yield call(FServiceAPI.InformalNode.createRules, params);

    const params2: Parameters<typeof ruleMatchAndResult>[0] = {
      nodeID: informExhibitInfoPage.node_ID,
      isRematch: true,
    };

    const result: RuleMatchAndResultReturn = yield call(ruleMatchAndResult, params2);
    if (result.status === 2) {
      fMessage('规则匹配失败');
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        node_RuleInfo: result,
      },
    });

    yield put<FetchInformalExhibitInfoAction>({
      type: 'fetchInformalExhibitInfo',
    });
  },
  * onChange_Side_Exhibit_Version({ payload }: OnChange_Side_Exhibit_Version_Action, {
    select,
    put,
    call,
  }: EffectsCommandMap) {
    const { informExhibitInfoPage }: ConnectState = yield select(({ informExhibitInfoPage }: ConnectState) => ({
      informExhibitInfoPage,
    }));

    const rules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> = (informExhibitInfoPage.node_RuleInfo?.testRules || []).map((rr) => {
      return rr.ruleInfo;
    });

    const text: string = decompile(mergeRules({
      oldRules: rules,
      exhibitName: informExhibitInfoPage.exhibit_Name,
      action: {
        operation: 'replace',
        content: {
          replacer: {
            name: informExhibitInfoPage.side_Resource_Relation?.name || '',
            versionRange: payload.value,
            type: informExhibitInfoPage.side_Resource_Relation?.identity || 'resource',
          },
          replaced: {
            name: informExhibitInfoPage.side_Resource_Relation?.name || '',
            versionRange: '*',
            type: informExhibitInfoPage.side_Resource_Relation?.identity || 'resource',
          },
          scopes: [],
        },
      },
    }));

    const params: Parameters<typeof FServiceAPI.InformalNode.createRules>[0] = {
      nodeId: informExhibitInfoPage.node_ID,
      testRuleText: text,
    };
    const { data } = yield call(FServiceAPI.InformalNode.createRules, params);

    const params2: Parameters<typeof ruleMatchAndResult>[0] = {
      nodeID: informExhibitInfoPage.node_ID,
      isRematch: true,
    };

    const result: RuleMatchAndResultReturn = yield call(ruleMatchAndResult, params2);
    if (result.status === 2) {
      fMessage('规则匹配失败');
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        node_RuleInfo: result,
      },
    });

    yield put<FetchInformalExhibitInfoAction>({
      type: 'fetchInformalExhibitInfo',
    });
  },
};
